import {request} from "../../base/HTTP";
import HttpMethod from "../../constants/HttpMethod";

export async function getAllGuestSearches() {
    return await request('/api/guest_search', {}, HttpMethod.GET);
}

export async function deleteGuestSearch(id) {
    return await request('/api/delete_email/' + id, {}, HttpMethod.DELETE);
}